var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"value":_vm.value,"persistent":"","max-width":"350"}},[_c('v-card',[_c('v-card-title',[_vm._v("Warning")]),_c('v-card-text',{staticClass:"black--text"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.formattedMessage)}})]),_c('v-card-actions',[_c('g-button',{attrs:{"label":"OK"},on:{"onclick":_vm.save}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }